//import { SubscriptionTypes } from 'constants/enums';
import { useTranslation } from 'react-i18next';

import { Job } from 'types/jobs';
import { JobseekerMatchesData } from 'types/jobseekers';

import MatchesCard from '../MatchesCard/MatchesCard';
import styles from '../MatchesView.module.scss';

interface ContentBlockProps {
  isLoadingJobseekers: boolean;
  jobId: string;
  job: Job | null;
  jobseekersMatchesDataList?: JobseekerMatchesData[];
  handleSetInviteSent: (jobseekerId: string) => void;
  isAIMatches?: boolean;
}

// const hasProSubscription = (job: Job | null): boolean => {
//   return (
//     job?.subscriptionType === SubscriptionTypes.Paid ||
//     job?.subscriptionType === SubscriptionTypes.Concierge
//   );
// };

const ContentBlock = ({
  isLoadingJobseekers,
  jobId,
  // job,
  jobseekersMatchesDataList,
  handleSetInviteSent,
  isAIMatches
}: ContentBlockProps) => {
  const { t } = useTranslation();
  if (isLoadingJobseekers) {
    return <div>{t('common.loading')}</div>;
  }

  const hasMatches =
    jobseekersMatchesDataList && jobseekersMatchesDataList.length > 0;
  //const isProSubscription = hasProSubscription(job);

  // if (!isProSubscription) {
  //   return (
  //     <div className={styles.noMatches}>
  //       Upgrade Job to PRO to see Jobseekers matches.
  //     </div>
  //   );
  // }

  if (hasMatches) {
    return (
      <>
        {jobseekersMatchesDataList.map((jobseekerMatchesData) => (
          <MatchesCard
            key={jobseekerMatchesData.jobseekerId}
            jobseekerMatchesData={jobseekerMatchesData}
            jobseekerId={jobseekerMatchesData.jobseekerId}
            jobId={jobId}
            handleSetInviteSent={handleSetInviteSent}
            isAIMatches={isAIMatches}
          />
        ))}
      </>
    );
  }

  return <div className={styles.noMatches}>{t('matches.noMatches')}</div>;
};

export default ContentBlock;
